import React from "react";

export default function LeftMargin() {
  return (
    <div className="ec-time-grid" style={{ display: "flex" }}>
      <div className="ec-sidebar">
        <div className="ec-sidebar-title">all-day</div>
      </div>
      <div className="ec-lines"></div>
    </div>
  );
}
